var _circle, _circle2, _circle3, _path, _path2, _circle4, _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNigeriaPoliceHousing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "#ffffff",
    stroke: "#1e40af",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 40,
    fill: "#1e40af"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25 L60 35 L60 55 L50 65 L40 55 L40 35 Z",
    fill: "#1e40af"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 30 L55 37 L55 52 L50 58 L45 52 L45 37 Z",
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 42,
    r: 4,
    fill: "#1e40af"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 46,
    width: 4,
    height: 8,
    fill: "#1e40af"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 6,
    fill: "#1e40af",
    fontWeight: "bold"
  }, "NPHS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaPoliceHousing);
export default __webpack_public_path__ + "static/media/nigeria-police-housing.ce87d064f8623f1eecd954816ab1cf4d.svg";
export { ForwardRef as ReactComponent };